import React from 'react'

const Section2 = () => {
    return (
        <div></div>
    )
}

export default Section2;
